import React from 'react'
import Loader from 'react-loaders'
import styled from 'styled-components'

export const L = ({ style, type, size, ...loaderProps }) => (
  <div style={style || {}} className="loader-container">
    <Loader type={type || 'ball-spin-fade-loader'} size={size || 'md'} active {...loaderProps} />
  </div>
)

const OverlapContainer = styled.div`
  position: absolute;
  top: ${(props) => props.margin}px;
  left: ${(props) => props.margin}px;
  right: ${(props) => props.margin}px;
  bottom: ${(props) => props.margin}px;
  background: var(--color-elevated);
  z-index: 4;
`

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: var(--z-index-modal);

  .loader-modal {
    width: 150px;
    height: 150px;
    padding: 50px;
    border-radius: 6px;
    position: absolute;
    top: calc(50% - 75px);
    left: calc(50% - 75px);
    background: var(--color-elevated);
  }
`

function CenteredLoader(props) {
  if (props.overlap) {
    return (
      <OverlapContainer
        margin={props.overlapMargin || 0}
        className="loader-overlap-container"
        style={props.style}
      >
        <L {...props} />
      </OverlapContainer>
    )
  } else if (props.modal) {
    return (
      <ModalContainer className="loader-modal-container">
        <div className="loader-modal">
          <L {...props} />
        </div>
      </ModalContainer>
    )
  } else return <L {...props} />
}

export default CenteredLoader
